export const IS_LOGIN = 'IS_LOGIN'; 
export const SET_USER_AUTHORITY = 'SET_USER_AUTHORITY';
export const SET_FILTER_PAST_MAINTENANCE_LIST = 'SET_FILTER_PAST_MAINTENANCE_LIST';
export const SET_DEFAULT_VALUES = 'SET_DEFAULT_VALUES';